// 生成二维码的全局域名
const baseUrl =  'https://admin.hezijiyin.com/public/api.php/'
// 测试域名1
// const baseUrl =  'https://weixin.hxyljk.com/public/api.php/'

// 图片域名
// const imgUrl = 'https://hezi-cdn.oss-cn-shenzhen.aliyuncs.com' // 临时正式
const imgUrl = 'https://cdn.hezijiyin.com/'


export default {
  baseUrl,
  imgUrl
}



// WEBPACK FOOTER //
// ./src/domain/domain.js